var $5cb1939fecdd5f1a$exports = {};
$5cb1939fecdd5f1a$exports = {
  "help": `Help`,
  "info": `Informatie`
};
export { $5cb1939fecdd5f1a$exports as default };